exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.el-form-item[data-v-76c3944d] {\r\n  margin-bottom: 24px;\n}\r\n", ""]);

// exports
